import React from 'react'

const ChairMenu: React.FC = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      y="0.5"
      width="32"
      height="32"
      rx="6.64935"
      fill="url(#paint0_linear_103_17189)"
      fillOpacity="0.1"
    />
    <g clipPath="url(#clip0_103_17189)">
      <path
        d="M22.57 15.8076C21.0447 15.8076 19.8037 17.0487 19.8037 18.5739V19.0791C19.1913 18.8602 18.0066 18.5739 16 18.5739C13.9934 18.5739 12.8091 18.8602 12.1963 19.0791V18.5739C12.1963 17.0487 10.9553 15.8076 9.43002 15.8076C8.47668 15.8076 7.70108 16.5832 7.70108 17.5366C7.70108 18.2368 8.11879 18.8637 8.76576 19.1331C8.9594 19.2143 9.08423 19.4021 9.08423 19.6113L9.43002 20.9944C9.43002 22.2358 10.3702 23.2611 11.576 23.3984C11.2921 23.5339 11.0943 23.8216 11.0943 24.157C11.0943 24.6225 11.4719 25.0001 11.9373 25.0001C12.4028 25.0001 12.7804 24.6225 12.7804 24.157C12.7804 23.8341 12.5964 23.5567 12.3295 23.415H19.6716C19.4046 23.5564 19.2207 23.8337 19.2207 24.157C19.2207 24.6225 19.5983 25.0001 20.0637 25.0001C20.5291 25.0001 20.9067 24.6225 20.9067 24.157C20.9067 23.8216 20.7089 23.5339 20.425 23.3984C21.6298 23.2611 22.57 22.2358 22.57 20.9944L22.9158 19.6113C22.9158 19.4017 23.0406 19.2143 23.2342 19.1331C23.8812 18.864 24.2989 18.2368 24.2989 17.5366C24.2989 16.5832 23.5233 15.8076 22.57 15.8076Z"
        fill="#052351"
      />
      <path
        d="M13.1472 17.7654C13.8668 17.634 14.8036 17.5365 16 17.5365C17.1964 17.5365 18.1332 17.634 18.8527 17.7654C19.1245 16.5137 20.016 15.4922 21.1872 15.0334V13.1876C21.1872 10.323 18.8648 8.00073 16 8.00073C13.1355 8.00073 10.8132 10.323 10.8132 13.1876V15.0337C11.9844 15.4926 12.8755 16.514 13.1472 17.7654Z"
        fill="#052351"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_103_17189"
        x1="15.7922"
        y1="0.5"
        x2="15.7922"
        y2="32.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0062FF" />
        <stop offset="1" stopColor="#004BC2" />
      </linearGradient>
      <clipPath id="clip0_103_17189">
        <rect width="17" height="17" fill="white" transform="translate(7.5 8)" />
      </clipPath>
    </defs>
  </svg>
)

export default ChairMenu
